export default "__VITE_ASSET__CsNeFVO3__"